<template>
  <v-dialog v-model="visible" max-width="1000" persistent>
    <v-card>
      <v-card-title class="text-h6 grey lighten-1">
         <v-icon class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">mdi-file-plus-outline</v-icon>
         {{ $t ('Nuevo informe') }}
      </v-card-title>

      <v-card-text class="pa-0">
        <v-stepper v-model="numeroPaso" style="background: #F0F0EE" flat>
          <v-stepper-header>
            <v-stepper-step :complete="numeroPaso > 1" step="1">
              {{ $t ('Seleccion de aparcamiento(s)') }}
              <small v-if="numeroPaso > 1" class="mt-2">{{nombreAparcamientoSeleccionado}}</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="numeroPaso > 2" step="2">
              {{ $t ('Selección de informe') }}
              <small v-if="numeroPaso > 2" class="mt-2">{{nombreInformeSeleccionado}}</small>
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="numeroPaso > 3" step="3">
              {{ $t ('Parametrización') }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="numeroPaso > 4" step="4">
              {{ $t ('Fin') }}
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>

            <!-- SELECCION DE APARCAMIENTO(S) -->

            <v-stepper-content step="1" class="pa-0">

              <v-card flat tile>
                <v-card-text class="pa-0">
                  <div class="contenedor-desplazable">
                    <v-data-table
                      v-model="seleccionAparcamientos"
                      :headers="cabecerasAparcamientos"
                      :items="arrayAparcamientos"
                      :search="busquedaAparcamiento"
                      item-key="id_ins"
                      dense
                      :show-select="false"
                      :single-select="!false"
                      @click:row="tablaAparcamientosClickRow"
                      @current-items="tablaAparcamientosCurrentItems"
                      @dblclick:row="tablaAparcamientosDblClickRow"
                    >
                      <template v-slot:top>
                        <v-container fluid style="background: #dcdcd0;" class="px-0">
                          <v-text-field
                            ref="busquedaAparcamiento"
                            style="width: 280px"
                            append-icon="mdi-magnify"
                            v-model="busquedaAparcamiento"
                            label="Buscar aparcamiento"
                            class="mx-4"
                            hide-details
                            @keypress.enter="tablaAparcamientosDblClickRow"
                          ></v-text-field>
                        </v-container>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" :disabled="seleccionAparcamientos.length == 0" @click="botonIrASeleccionInforme">{{ $t ('Siguiente') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

            <!-- SELECCIÓN DE INFORME -->

            <v-stepper-content step="2" class="pa-0">

              <v-card flat tile>
                <v-card-text class="pa-0">
                  <div class="contenedor-desplazable">
                    <v-data-table
                      v-model="seleccionInformes"
                      :headers="cabecerasInformes"
                      :items="arrayInformes"
                      :loading="cargandoInformes"
                      :search="busquedaInforme"
                      item-key="fichero"
                      dense
                      single-select
                      @click:row="tablaInformesClickRow"
                      @current-items="tablaInformesCurrentItems"
                      @dblclick:row="tablaInformesDblClickRow"
                    >
                      <template v-slot:top>
                        <v-container fluid style="background: #dcdcd0;" class="px-0">
                          <v-text-field
                            ref="busquedaInforme"
                            style="width: 280px"
                            append-icon="mdi-magnify"
                            v-model="busquedaInforme"
                            label="Buscar informe"
                            class="mx-4"
                            hide-details
                            @keypress.enter="tablaInformesDblClickRow"
                          ></v-text-field>
                        </v-container>
                      </template>

                      <template v-slot:[`item.tipo`]="{ item }">
                        {{literalTipoInforme (item.tipo)}}
                      </template>

                    </v-data-table>
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-btn text color="#90908E" @click="botonIrASeleccionAparcamiento">{{ $t ('Atrás') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn text color="green darken-2" :disabled="seleccionInformes.length == 0" @click="botonIrAParametrizacion">{{ $t ('Siguiente') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

            <!-- PARAMETRIZACIÓN -->

            <v-stepper-content step="3" class="pa-0">

              <v-card flat tile>
                <v-card-text>
                  <div class="contenedor-desplazable" style="padding-left: 3%;">
                    <v-progress-linear
                      v-if="cargandoParametros"
                      indeterminate
                      color="green"
                    ></v-progress-linear>
                    <v-row v-else no-gutters>
                      <v-col cols="auto">
                        <div style="writing-mode: tb-rl; font-size: 20px; color: #bbb; transform: rotate(180deg); padding-left: 20px; padding-bottom: 5px;">{{nombreInformeSeleccionado}}</div>
                      </v-col>
                      <v-col>
                        Parámetros:
                        <ParametrosInforme :array-parametros="arrayParametrosInforme" />
                      </v-col>
                    </v-row>
                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-btn text color="#90908E" @click="botonIrASeleccionInforme">{{ $t ('Atrás') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn ref="botonIrAFin" text color="green darken-2" @click="botonIrAFin">{{ $t ('Siguiente') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

            <!-- FIN -->

            <v-stepper-content step="4" class="pa-0">

              <v-card flat tile>
                <v-card-text>
                  <div class="contenedor-desplazable" style="padding-left: 3%;">

                    <v-text-field
                      ref="referencia"
                      prepend-icon="mdi-bookmark-outline"
                      :label="$t ('Referencia')"
                      hide-details
                      v-model="referencia"
                      class="mr-5 mb-5"
                      @keypress.enter="$refs.inputCorreoElectronico.focus"
                    />

                    <v-icon class="mr-3">mdi-format-page-break</v-icon>Formato:
                    <v-radio-group
                      v-model="formatoDeInforme"
                      class="ml-10 mt-2">
                      <v-radio label="PDF" value="PDF"></v-radio>
                      <v-radio label="HTML" value="HTML"></v-radio>
                      <v-radio label="CSV" value="CSV"></v-radio>
                      <v-radio label="TSV" value="TSV"></v-radio>
                      <v-radio label="TXT" value="TXT"></v-radio>
                    </v-radio-group>

                    <v-text-field
                      ref="inputCorreoElectronico"
                      prepend-icon="mdi-email-send-outline"
                      :label="$t ('Enviar copia del informe al correo electrónico')"
                      hide-details
                      v-model="copiaACorreoElectronico"
                      class="mt-n1"
                      style="width: 50%"
                      @keypress.enter="$refs.botonSolicitarInforme.$el.focus"
                    />

                  </div>
                </v-card-text>

                <v-card-actions>
                  <v-btn text color="#90908E" @click="botonIrAParametrizacion">{{ $t ('Atrás') }}</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn ref="botonSolicitarInforme" text color="green darken-2" @click="botonSolicitarInforme">{{ $t ('Solicitar informe') }}</v-btn>
                  <v-btn text @click="botonCancelarClick">{{ $t ('Cancelar') }}</v-btn>
                </v-card-actions>
              </v-card>

            </v-stepper-content>

          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { DateTime } from "luxon";
import ParametrosInforme from "@/components/ParametrosInforme.vue";
import api from "@/api";

export default {
  components: { ParametrosInforme },
  data () {
    return {
      cabecerasInformes: [
        { text: this.$t ("Número"), value: "numero", align: "center" },
        { text: this.$t ("Informe"), value: "titulo" },
        { text: this.$t ("Tipo"), value: "tipo" },
        //{ text: this.$t ("Etiquetas"), value: "etiquetas" },
      ],
      cabecerasAparcamientos: [
        { text: this.$t ("Aparcamiento"), value: "nom" },
      ],

      sagabroker: null,

      visible: false,
      numeroPaso: 1,

      arrayAparcamientos: [],
      seleccionAparcamientos: [],
      busquedaAparcamiento: '',

      cargandoInformes: false,
      arrayInformes: [],
      seleccionInformes: [],
      busquedaInforme: '',

      cargandoParametros: false,
      preparativosInforme: null,

      formatoDeInforme: null,
      referencia: null,
      copiaACorreoElectronico: null,
    }
  },
  computed: {
    nombreAparcamientoSeleccionado () {
      if (this.seleccionAparcamientos.length > 1)
        return this.$t ('(Varios)');
      else if (this.seleccionAparcamientos[0])
        return this.seleccionAparcamientos[0].nom;
      else
        return '';
    },
    nombreInformeSeleccionado () {
      if (this.seleccionInformes[0])
        return this.seleccionInformes[0].titulo;
      else
        return '';
    },
    arrayParametrosInforme () {
      if (this.preparativosInforme)
        return this.preparativosInforme.parametros
      else
        return [];
    }
  },
  methods: {
    literalTipoInforme (tipo) {
      switch (tipo) {
        case 1: return "SAGA";
        case 2: return "SAGA (multi-aparcamiento)";
        case 3: return "ARIS";
        case 4: return "ARIS (multi-aparcamiento)";
        default: return "(Desconocido)";
      }
    },
    idInstalacionSeleccionada () {
      if (this.seleccionAparcamientos.length == 1)
        return this.seleccionAparcamientos[0].id_ins;
      else
        return null;
    },
    abrirVentana (sagabroker) {
      this.sagabroker = sagabroker;

      this.arrayAparcamientos = this.$tablasConsulta.arrayRegistros ('ins');
      this.seleccionAparcamientos = [];
      this.busquedaAparcamiento = '';

      this.cargandoInformes = false;
      this.arrayInformes = [];
      this.seleccionInformes = [];
      this.busquedaInforme = '';

      this.cargandoParametros = false;
      this.preparativosInforme = null;

      this.formatoDeInforme = 'PDF';
      this.referencia = '';
      this.copiaACorreoElectronico = '';

      this.botonIrASeleccionAparcamiento();

      this.visible = true;
    },

    // tabla de aparcamientos
    tablaAparcamientosClickRow (fila) {
      this.seleccionAparcamientos = [fila];
    },
    tablaAparcamientosDblClickRow () {
      this.botonIrASeleccionInforme();
    },
    tablaAparcamientosCurrentItems (filas) {
      if (filas.length == 1)
        this.seleccionAparcamientos = filas;
      else
        this.seleccionAparcamientos = [];
    },

    // tabla de informes
    tablaInformesClickRow (fila) {
      this.seleccionInformes = [fila];
    },
    tablaInformesDblClickRow () {
      this.botonIrAParametrizacion();
    },
    tablaInformesCurrentItems (filas) {
      if (filas.length == 1)
        this.seleccionInformes = filas;
      else
        this.seleccionInformes = [];
    },

    // parametros
    parametrosAAplicar () {
      let resultado = [];
      this.arrayParametrosInforme.forEach (parametro => {
        if (parametro.activo) {
          let valor = null;
          let descripcion_valor = null;
          if (parametro.valor) {
            valor = parametro.valor.value ? parametro.valor.value : parametro.valor;
            if ([5, 8].includes (parametro.tipo_valor))
              descripcion_valor = DateTime.fromISO (parametro.valor).setLocale("es").toLocaleString (DateTime.DATETIME_SHORT)
            else if (parametro.tipo_valor == 6)
              descripcion_valor = null;
            else if (parametro.tipo_valor == 7)
              descripcion_valor = parametro.valor.text;
            else if (parametro.tipo_valor == 9)
              descripcion_valor = parametro.valor ? this.$t ('Sí') : this.$t ('No');
            else
              descripcion_valor = parametro.valor;
          }
          resultado.push ({ nombre: parametro.nombre, titulo: parametro.titulo, valor: valor, descripcion_valor: descripcion_valor });
        }
      });
      return resultado;
    },

    // botones de navegación
    botonIrASeleccionAparcamiento () {
      this.numeroPaso = 1;
      setTimeout (() => { this.$refs['busquedaAparcamiento'].focus(); }, 250); // establecemos el foco en el campo de busqueda
    },
    botonIrASeleccionInforme () {
      if (this.numeroPaso == 1) {
        if (this.seleccionAparcamientos.length == 0)
          return;

        this.cargandoInformes = true;
        this.seleccionInformes = [];
        this.arrayInformes = [];

        api.obtenerRepertorioInformes ({ id_instalacion: this.idInstalacionSeleccionada() })
          .then ((respuesta) => {
            this.arrayInformes = respuesta.data.informes;
          })
          .catch(() => {
            alert ('ERROR: Obteniendo repertorio de informes');
          })
          .finally(() => {
            this.cargandoInformes = false;
          });
      }
      this.numeroPaso = 2;
      setTimeout (() => { this.$refs['busquedaInforme'].focus(); }, 250); // establecemos el foco en el campo de busqueda
    },
    botonIrAParametrizacion () {
      if (this.numeroPaso == 2) {
        if (this.seleccionInformes.length == 0)
          return;

        this.cargandoParametros = true;
        this.preparativosInforme = null;

        api.obtenerPreparativosInforme ({ id_instalacion: this.seleccionInformes[0].id_instalacion,
                                          fichero_informe: this.seleccionInformes[0].fichero })
          .then ((respuesta) => {
            respuesta.data.parametros.forEach  ((parametro) => {
              this.$set (parametro, 'activo', parametro.estado_parametro > 0);
              parametro.titulo = parametro.titulo.replace (':', '');

              if ([5, 8].includes (parametro.tipo_valor)) {
                if (parametro.valor_por_defecto_tiempo_relativo > 0) {
                  let fechaHora = DateTime.local().plus ({ days: parametro.valor_por_defecto_numerico });
                  if (parametro.valor_por_defecto_tiempo_relativo == 2) fechaHora = fechaHora.set({ Hour: 0, Minute: 0, Second: 0, Millisecond: 0 });
                  else if (parametro.valor_por_defecto_tiempo_relativo == 3) fechaHora = fechaHora.set({ Hour: 23, Minute: 59, Second: 59, Millisecond: 998 });
                  parametro.valor = fechaHora.toISO ({ includeOffset: false });
                } else
                  parametro.valor = parametro.valor_por_defecto_iso8601;
              } else {
                parametro.valor = parametro.valor_por_defecto;
              }

              if (parametro.dominio_valores) {
                parametro.dominio_valores__VT = [];
                Object.entries (parametro.dominio_valores).forEach (([clave, valor]) => {
                  parametro.dominio_valores__VT.push ({ value: clave, text: valor });
                });
                parametro.valor = parametro.dominio_valores__VT.find (elemento => elemento.value == parametro.valor)
                if ((parametro.valor == null) && (parametro.dominio_valores__VT.length > 0))
                  parametro.valor = parametro.dominio_valores__VT[0]; // seleccionamos por defecto el primero de los valores
              }
            });
            this.preparativosInforme = respuesta.data;
          })
          .catch((e) => {
            console.error (e);
            alert ('ERROR: Obteniendo preparativos de informe');
          })
          .finally(() => {
            this.cargandoParametros = false;
          });
      }
      this.numeroPaso = 3;
      setTimeout (() => { this.$refs['botonIrAFin'].$el.focus(); }, 250); // establecemos el foco en el boton
    },
    botonIrAFin () {
      this.numeroPaso = 4;
      setTimeout (() => { this.$refs['referencia'].focus(); }, 250); // establecemos el foco en el campo de busqueda
    },
    botonSolicitarInforme () {
      api.generarInforme ({ instalaciones: this.seleccionAparcamientos,
                            informe: this.seleccionInformes[0],
                            parametros: this.parametrosAAplicar(),
                            referencia: this.referencia,
                            formato: this.formatoDeInforme,
                            correo_electronico: this.copiaACorreoElectronico,
                           });
      this.visible = false;
    },
    botonCancelarClick () {
      this.visible = false;
    }
  }
}
</script>

<style>
.contenedor-desplazable {
  min-height: 40vh;
  max-height: 55vh;
  overflow-y: auto;
}
</style>